import * as colors from '@giphy/colors'
import Clipboard from 'clipboard'
import PropTypes from 'prop-types'
import { PureComponent } from 'react'
import { Button } from 'shared/components/buttons'
import { gridSpacing } from 'shared/css/grid.css'
import styled from 'styled-components'
import Social from './social'

const Container = styled.div`
    clear: both;
`

const Block = styled.div`
    border-top: 1px solid ${colors.giphyDarkGrey};
    padding: 30px 0;
`

const Label = styled.h3`
    color: ${colors.giphyLightGrey};
    font-size: 14px;
    margin: 0 0 ${gridSpacing};
    text-transform: uppercase;
`

const Copy = styled(Button).attrs({ as: 'div' })`
    display: inline-block;
    margin: 0 0 ${gridSpacing};

    &:before {
        display: inline-block;
        margin-right: 5px;
        vertical-align: middle;
    }
`

export default class StoryFooter extends PureComponent {
    static propTypes = {
        slug: PropTypes.string.isRequired,
    }
    clipboard = null
    componentDidMount() {
        this.clipboard = new Clipboard('.copy-btn')
        this.clipboard.on('success', () => {
            global.showSuccess('Story link copied to clipboard!')
        })
        this.clipboard.on('error', () => global.showError('There was an issue copying the story link.'))
    }
    componentWillUnmount() {
        this.clipboard && this.clipboard.destroy()
    }
    render() {
        const { slug } = this.props
        const url = `https://giphy.com/stories/${slug}`
        return (
            <Container>
                <Block>
                    <Label>Liked it? Share it!</Label>
                    <Copy className="copy-btn ss-link" color={colors.giphyDarkGrey} data-clipboard-text={url}>
                        Copy Story Link
                    </Copy>
                    <Social url={url} />
                </Block>
            </Container>
        )
    }
}
